export const segmenteOptions = [
  { label: "Age", value: "age" },
  { label: "Gender", value: "gender" },
  { label: "Subscription Type", value: "subscription_type" },
  // { label: "Search Interest", value: "search_interest" },
  { label: "By sexual orientation", value: "sexual_orientation" },
  { label: "By country", value: "country" },
  { label: "By language", value: "language" },
];

export const genderOptions = [
  "Men",
  "CisMen",
  "IntersexMen",
  "TransMen",
  "Transmasculine",
  "Woman",
  "CisWoman",
  "IntersexWoman",
  "TransWoman",
  "Transfeminine",
  "BeyondBinary",
  "Agender",
  "Androgyne",
  "Bigender",
  "Genderfluid",
  "GenderQuestioning",
  "Genderqueer",
  "Intersex",
  "Neutrois",
  "Nonbinary",
  "Pangender",
  "TransPerson",
  "TwoSpirit",
  "NotListed",
];

export const sexualOrientationOptions = [
  "Straight",
  "Bisexual",
  "Gay",
  "Lesbian",
  "Aromantic",
  "Asexual",
  "Demisexual",
  "Omnisexual",
  "Pansexual",
  "Queer",
  "Questioning",
  "NotListed",
];

export const languageOptions = ["English", "Spanish", "French"];

export const subscriptionTypeOptions = ["Full", "Free", "Plus"];
